import { inject, Pipe, PipeTransform } from "@angular/core";
import { ConfigurationService } from "common/configuration.service";

@Pipe({
	name: "allowedProtocolsCheck",
	pure: true,
})
export class AllowedProtocolsCheckPipe implements PipeTransform {
	configurationService = inject(ConfigurationService);

	async transform(stringToCheck: string): Promise<boolean> {
		return (await this.configurationService.getURLAllowedProtocolsProperty()).protocols.some((protocol: string) =>
			stringToCheck.toLowerCase().startsWith(`${protocol.toLowerCase()}:`),
		);
	}
}
